import { DateTime, Interval } from "luxon";
import Vue from "vue";

function createActions() {
  var actions = {};
  Object.keys(flink.event).forEach(f => {
    actions[f] = function({ commit }, args) {
      commit("loading", true, { root: true });
      return flink.event[f](args)
        .then(result => {
          if (Array.isArray(result)) {
            result.forEach(e => {
              commit("setEventById", { id: e.id, body: e });
            });
          } else {
            commit("setEventById", { id: result.id, body: result });
          }
          return result;
        })
        .then(result => {
          commit("loading", false, { root: true });
          return result;
        })
        .catch(err => {
          commit("loading", false, { root: true });
          throw err;
        });
    };
  });
  return actions;
}

function setFromJson(events, body) {
  const id = body.id;
  for (var key in body.sessions) {
    var session = body.sessions[key];
    session.start = DateTime.fromISO(session.start, {
      setZone: true
    });
    session.end = DateTime.fromISO(session.end, { setZone: true });
  }

  events[id] = events[id] || {};
  events[id].name = body.name;
  events[id].id = body.id;
  events[id].details = body.details;
  events[id].start = DateTime.fromISO(body.start, { setZone: true }).startOf(
    "day"
  );
  events[id].end = DateTime.fromISO(body.end, { setZone: true }).startOf("day");
  events[id].sessions = body.sessions;
  events[id].rooms = body.rooms;
}
export default function() {
  return {
    namespaced: true,
    state: {
      events: {}
    },
    getters: {
      events: state => state.events,
      event: state => id => state.events[id]
    },
    mutations: {
      setEventById(state, { id, body }) {
        setFromJson(state.events, body);
      }
    },
    actions: createActions()
  };
}



// WEBPACK FOOTER //
// ./src/store/modules/events.js